module.exports = __webpack_public_path__ + "static/media/what_is_personal_data.6878fb74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/what_is_personal_data.jpg
// module id = 220
// module chunks = 0